import { appInsights } from '../app-insights';
import { telemetryKeyPrefix } from '../utils/telemetryKeyPrefix';

import type { PaymentStatusEvent } from './types';

const EVENT_GUEST_PAYMENT_STATUS = 'PAY_NOW';

export const logGuestPaymentStatusEvent = ({
  checkoutSessionId,
  paymentStatus,
  customerId,
}: PaymentStatusEvent) => {
  appInsights.trackEvent({
    name: EVENT_GUEST_PAYMENT_STATUS,
    properties: {
      [telemetryKeyPrefix('paymentStatus')]: paymentStatus,
      [telemetryKeyPrefix('customerId')]: customerId,
      [telemetryKeyPrefix('checkoutSessionId')]:
        checkoutSessionId,
    },
  });
};
